import { Component, OnInit } from '@angular/core';
// import gql from 'graphql-tag';
// import { APIService } from '../../../API.service';
import {AccessGroupService} from './../../access-group.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
// import { Apollo } from 'apollo-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { DatepickerOptions } from 'ng2-datepicker';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { generateClient } from 'aws-amplify/data';
import { Schema } from './../../../../../amplify/data/resource';
const client = generateClient<Schema>();

declare var jQuery: any;

@Component({
  selector: 'app-dynamic-learner-map',
  templateUrl: './dynamic-learner-map.component.html',
  styleUrls: ['./dynamic-learner-map.component.scss']
})
export class DynamicLearnerMapComponent implements OnInit {

  public currentLM_id: string;
  public currentLM: any;
  public allcolumns:any;
  public learner_map: string;
  public child: string = '';
  email:string = localStorage.getItem('email');
  designView: boolean = false;
  lm_maptype:string = '';

  constructor(private accessgroup: AccessGroupService, private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute, private modalService: NgbModal, private router: Router) { }

    ngOnInit() { 
      localStorage.setItem('appNoli','false');   
      var that = this;
        
      if(this.activatedRoute.firstChild){
        this.activatedRoute.firstChild.params.subscribe((params: Params) => {
              this.child = params['id'];
        }); 
      }
        this.activatedRoute.params.subscribe(async (params: Params) => {
          this.currentLM = '';
          if(this.currentLM_id != params['id']){
              this.currentLM_id = params['id'];
              var that = this;
              // const data = await client?.models?.Column?.list({learnermapID: params['id']})

              const { data: LearnerMap } = await client.models.LearnerMap.get(
                { id: params["id"] },
                { selectionSet: ["id", "maptype.*", "id", "columns.*"] }
              );
              


              console.warn("LearnerMap====>",LearnerMap);

              const lrnrmap:any = await client?.models?.LearnerMap?.get({id: params['id']})
              console.log('dynamic learner map LM',lrnrmap)
              const { data: data} = await lrnrmap?.data?.columns({limit: 10000});
              console.log("col==>",data)


              // const data:any = await client?.models?.Column?.list({
              //   filter: {
              //     columnLearnermapId: { eq: params['id'] }
              //   }
              // });

              data.forEach(async (item, i)=> {
                let cards:any = await item.cards({limit: 10000});
                console.warn(cards)
                item.cards = cards.data
                // allcards.push(cards.data)
              })
              // data.data.forEach(async (item, i)=> {
              //   let cards:any =  await client?.models?.Card.list({
              //     filter: {
              //       cardColumnId: { eq: item.id }
              //     }
              //   })
              //   if(cards.data){
              //     item.cards = cards.data
              //   }
              // })
              console.log('dynamic learner map',data)

              lrnrmap.data.columns = data;
              console.log("LearnerMap", lrnrmap)
              // let map = data?.data;
              //    that.lm_maptype = map?.maptype['title'];
                      if(lrnrmap?.data?.owners?.includes(localStorage.getItem('email'))){
                          that.designView = true;
                      }
                  that.learner_map = '';
                  let removeHash = lrnrmap.data['title'];
                  for(let i = 0; i< removeHash.length; i++) {
                    if(removeHash[i] !== '#') {
                      that.learner_map += removeHash[i];
                    }
                    if(removeHash[i] === '#') {
                      that.learner_map += ' ';
                    }

                  }
              that.currentLM = lrnrmap.data
              that.allcolumns = data.data;  

          
          // this.api.GetLearnerMap(this.currentLM_id).then(function (map) {
          //   console.warn(map);
          //   that.lm_maptype = map?.maptype['title'];
          //             if(map?.owners?.includes(localStorage.getItem('email'))){
          //                 that.designView = true;
          //             }
          //   that.learner_map = '';
          //   let removeHash = map['title'];
          //   for(let i = 0; i< removeHash.length; i++) {
          //     if(removeHash[i] !== '#') {
          //       that.learner_map += removeHash[i];
          //     }
          //     if(removeHash[i] === '#') {
          //       that.learner_map += ' ';
          //     }

          //   }
          //   that.currentLM = map;
          //   that.allcolumns = that.currentLM.columns.items;  
          // })
        }
      });
      
    }

  
}
